module.exports = __webpack_public_path__ + "static/media/teléfono.ce593d20.png";